import React from "react";
import "./chart.css";
import { useReveal } from "../../lib/useReveal";

const format = (value) => (value >= 10 ? value.toFixed(2) : value.toString());

/**
 * Horizontal bar chart. Rendered as a real <table> so the numbers are available
 * to assistive tech; the bars are a visual layer that grows in on first view.
 */
const BarChart = ({ title, unit, bars, threshold, caption }) => {
  const [ref, shown] = useReveal({ threshold: 0.25 });
  const max = Math.max(...bars.map((b) => b.value));

  return (
    <figure className="bchart" ref={ref} data-shown={shown}>
      <figcaption className="bchart__title">{title}</figcaption>
      <table className="bchart__table">
        <caption className="sr-only">
          {title} ({unit})
        </caption>
        <thead className="sr-only">
          <tr>
            <th scope="col">Item</th>
            <th scope="col">{unit}</th>
          </tr>
        </thead>
        <tbody>
          {bars.map((bar, i) => (
            <tr key={bar.label} className="bchart__row" data-highlight={bar.highlight || (threshold && bar.value >= threshold.value) || undefined}>
              <th scope="row" className="bchart__label">
                {bar.label}
              </th>
              <td className="bchart__cell">
                <span className="bchart__track">
                  <span
                    className="bchart__bar"
                    style={{ "--w": `${(bar.value / max) * 100}%`, "--i": i }}
                  />
                  {threshold && (
                    <span
                      className="bchart__threshold"
                      style={{ left: `${(threshold.value / max) * 100}%` }}
                      title={threshold.label}
                    />
                  )}
                </span>
                <span className="bchart__value">{format(bar.value)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {threshold && <p className="bchart__legend">┆ {threshold.label}</p>}
      {caption && <p className="bchart__caption">{caption}</p>}
    </figure>
  );
};

export default BarChart;
